import React from "react";

export default function Arrow() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer"
      fill="currentColor"
    >
      <path
        className="cursor-pointer"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9999 5.00063C13.9999 4.86802 13.9472 4.74085 13.8535 4.64708C13.7597 4.55331 13.6325 4.50063 13.4999 4.50063H1.70692L4.85392 1.35463C4.9004 1.30814 4.93728 1.25295 4.96244 1.19222C4.9876 1.13148 5.00055 1.06638 5.00055 1.00063C5.00055 0.934888 4.9876 0.869788 4.96244 0.809048C4.93728 0.748309 4.9004 0.693119 4.85392 0.646631C4.80743 0.600144 4.75224 0.563267 4.6915 0.538108C4.63076 0.512949 4.56566 0.5 4.49992 0.5C4.43417 0.5 4.36907 0.512949 4.30833 0.538108C4.24759 0.563267 4.1924 0.600144 4.14592 0.646631L0.145917 4.64663C0.099354 4.69308 0.0624111 4.74825 0.0372047 4.809C0.0119982 4.86974 -0.000976563 4.93486 -0.000976562 5.00063C-0.000976563 5.0664 0.0119982 5.13152 0.0372047 5.19226C0.0624111 5.25301 0.099354 5.30819 0.145917 5.35463L4.14592 9.35463C4.1924 9.40112 4.24759 9.438 4.30833 9.46315C4.36907 9.48831 4.43417 9.50126 4.49992 9.50126C4.56566 9.50126 4.63076 9.48831 4.6915 9.46315C4.75224 9.438 4.80743 9.40112 4.85392 9.35463C4.9004 9.30814 4.93728 9.25295 4.96244 9.19221C4.9876 9.13148 5.00055 9.06637 5.00055 9.00063C5.00055 8.93489 4.9876 8.86979 4.96244 8.80905C4.93728 8.74831 4.9004 8.69312 4.85392 8.64663L1.70692 5.50063H13.4999C13.6325 5.50063 13.7597 5.44795 13.8535 5.35419C13.9472 5.26042 13.9999 5.13324 13.9999 5.00063Z"
      />
    </svg>
  );
}
